import { z } from 'zod';
import { ticketStatusSchema } from '../enums.js';
/**
 * Realtime contract (SPEC.md §5.3). Socket.IO, per the stack fixed in CLAUDE.md.
 *
 * Event names and room names live here so the gateway and the client cannot drift —
 * a typo in a room name is otherwise a silent failure where messages simply never
 * arrive.
 */
export const RealtimeEvent = {
    TicketCreated: 'ticket:created',
    TicketUpdated: 'ticket:updated',
    TicketMessage: 'ticket:message',
    DirectMessage: 'direct:message',
    /** Something landed in your feed — the badge refreshes off this (D30). */
    Notification: 'notification:new',
};
/** Everyone authenticated joins this, for the dashboard and queue feeds. */
export const TICKETS_FEED_ROOM = 'tickets';
/** Joined on demand when a ticket detail view is open. */
export function ticketRoom(ticketId) {
    return `ticket:${ticketId}`;
}
/**
 * Joined automatically at handshake for frontline staff, from their role.
 *
 * Lets a new fault reach the team that owns it without every phone on the property
 * waking for work that is not theirs.
 */
export function departmentRoom(department) {
    return `department:${department}`;
}
/**
 * Joined automatically at handshake, for everyone.
 *
 * A direct message has no room the recipient would think to subscribe to, and it has
 * to reach them on every device they are signed in on — including the one that is not
 * currently showing the conversation. Keyed on the user id rather than a conversation
 * id for exactly that reason: membership is known at connect time, before any thread
 * is open.
 */
export function userRoom(userId) {
    return `user:${userId}`;
}
/** Client asks to join or leave a ticket thread. */
export const ROOM_SUBSCRIBE = 'room:subscribe';
export const ROOM_UNSUBSCRIBE = 'room:unsubscribe';
export const ticketUpdatedPayloadSchema = z.object({
    ticketId: z.string(),
    reference: z.number().int(),
    status: ticketStatusSchema,
    /** Null when the change was made by the system, e.g. the escalation sweep. */
    actorId: z.string().nullable(),
    at: z.string(),
});
export const ticketMessagePayloadSchema = z.object({
    id: z.string(),
    ticketId: z.string(),
    body: z.string(),
    authorId: z.string().nullable(),
    authorName: z.string(),
    isInternal: z.boolean(),
    createdAt: z.string(),
    attachments: z.array(z.object({ id: z.string(), url: z.string(), mimeType: z.string() })),
});
//# sourceMappingURL=events.js.map